import { useQuery } from "@tanstack/react-query";

import { getBillingBalance } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { BILLING_QUERY_KEYS } from "./queryKeys";

export function useBillingBalanceQuery() {
  return useQuery({
    queryKey: BILLING_QUERY_KEYS.balance(),
    queryFn: processResponse(() => getBillingBalance()),
  });
}
